import {Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';

@Component({
	selector: 'hls-player',
	template: `<video class="w-100 h-100 static-color" #video controls [videoSubtitles]="videoSubtitles"></video>`,
})
export class HlsPlayerComponent implements OnChanges {
	@ViewChild('video', { static: true }) videoRef!: ElementRef<HTMLVideoElement>;
	@Input() src!: string; // m3u8 URL
	@Input() videoSubtitles: any[];

	ngOnChanges(changes: SimpleChanges) {
		if (changes?.src) {
			this.loadVideo();
		}
	}

	async loadVideo() {
		const video = this.videoRef.nativeElement;

		if (!this.src) return;

		// Native HLS (Safari)
		if (video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = this.src;
			return;
		}

		// Other browsers: dynamically load hls.js only when needed
		// @ts-ignore
		const { default: Hls } = await import('hls.js');

		if (Hls.isSupported()) {
			const hls = new Hls();
			hls.loadSource(this.src);
			hls.attachMedia(video);
		} else {
			console.error('HLS not supported');
		}
	}
}
